import { t } from "../../i18n";
import {
  type BackendApiCoverageSnapshot,
  parseBackendApiCoverageSnapshot,
} from "./backend-api-coverage-types";

export async function fetchBackendApiCoverageSnapshot(): Promise<BackendApiCoverageSnapshot> {
  const response = await fetch("/backend-api-coverage-snapshot.json", {
    cache: "no-store",
  });
  if (!response.ok) {
    throw new Error(t("api_coverage.snapshot_failed"));
  }
  const value: unknown = await response.json();
  const snapshot = parseBackendApiCoverageSnapshot(value);
  if (!snapshot) {
    throw new Error(t("api_coverage.snapshot_invalid"));
  }
  return snapshot;
}
